import DataStore from '../State/DataStore'
import SessionStore from '../State/SessionStore'
import OrganisationCollection from '../State/Collections/OrganisationCollection'

export const cleanupNewEntity = (entity, entityType, additionalCleanup) => {
    if (!entity || entity.createdAt) return false
    
    switch (entityType) {
        case 'invoice':
            if (entity.projectId) {
                SessionStore.organisation.decrementInvoiceNumber(entity.projectId)
                OrganisationCollection.update(
                    SessionStore.organisation.id,
                    {},
                    {
                        trackUpdates: false,
                        savedAt: Date.now(),
                    }
                )
            }
            DataStore.destroyNewItems('invoiceId', entity.id)
            DataStore.startSave()
            break
            
        case 'contact':
            DataStore.destroyNewItems('contactId', entity.id)
            break
            
        case 'project':
            DataStore.destroyNewItems('projectId', entity.id)
            break
            
        case 'staff':
            DataStore.destroyNewItems('staffId', entity.id)
            break
            
        case 'role':
            DataStore.destroyNewItems('roleId', entity.id)
            break
    }
    
    if (additionalCleanup) {
        additionalCleanup()
    }
    
    return true
}

export const handleEntityDelete = (entity, entityType, navigate, additionalCleanup) => {
    const isNewEntity = !entity.createdAt
    
    if (isNewEntity) {
        cleanupNewEntity(entity, entityType, additionalCleanup)
        
        const routeMap = {
            invoice: '/invoices',
            contact: '/contacts',
            project: '/projects',
            staff: '/staff',
            role: '/staff-roles'
        }
        navigate({ to: routeMap[entityType] || `/${entityType}s` })
    } else {
        entity.update({ deletedAt: new Date() })
        
        if (entityType === 'invoice' && entity.lineItems) {
            entity.lineItems.forEach((li) => {
                li.timeEntries.forEach((te) => {
                    te.update({ beenInvoiced: false })
                })
                li.expenseItems.forEach((ei) => {
                    ei.update({ beenInvoiced: false })
                })
                li.update({ deletedAt: new Date() })
            })
        }
        
        if (additionalCleanup) {
            additionalCleanup()
        }
        
        DataStore.startSave()
        const routeMap = {
            invoice: '/invoices',
            contact: '/contacts',
            project: '/projects',
            staff: '/staff',
            role: '/staff-roles'
        }
        navigate({ to: routeMap[entityType] || `/${entityType}s` })
    }
}